import { AddRemittanceContext } from '../../../../../components/Purchasing/Remittance/AddRemittance/AddRemittanceCont'
import React from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import MoneyCell from '../../../../../elements/Table/Cells/MoneyCell'

function List(props) {
  // const {lines, fetchLines, fetchingLines, onShow} = props
  const { lines, fetchLines, fetchingLines, onShow } = React.useContext(AddRemittanceContext)

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Voucher',
      accessor: 'voucher.code',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Voucher Amount',
      accessor: 'voucher.subTotal.gross',
      Cell: MoneyCell,
    },
    { Header: 'Allocation', accessor: 'allocation', Cell: MoneyCell },
  ]

  return (
    <CustomTable
      data={lines}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetchingLines}
      fetch={fetchLines}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
